import ckplayer from "./ckplayer";
import poylvplayer from "./poylvPlayer";
import courseChapter from "./courseChapter";
import noteItem from "./noteItem";
import advice from "./advice";
import certificate from "./certificate";

export default [ckplayer, courseChapter, noteItem, poylvplayer, advice, certificate];